const $inject = [];

const authService = function () {
  const service = {
    prevRoute: undefined,
    getUsername,
    logout,
    getOauth,
    getAccessToken,
    isAuthenticated,
    getFullname,
    getInitials
  };

  function getUsername() {
    if (!service.getOauth()) return;

    return service.getOauth().username;
  }

  function getFullname() {
    if (!service.getOauth()) return;

    return service.getOauth().fullname;
  }

  function getInitials() {
    var fullname = getFullname();
    if(fullname === null ||fullname === undefined) return '--';
    
    var words = fullname.split(' ');
    return words.map((word) => {
      return word[0];
    }).join('');
  }

  function logout() {
    localStorage.removeItem('oauth');
    if (window.auth0Client) {
      window.auth0Client.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    }
  }

  function getOauth() {
    return JSON.parse(localStorage.getItem('oauth'));
  }

  function getAccessToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.access_token : '';
  }

  function isAuthenticated() {
    var oauth = service.getOauth();
    if (oauth && oauth.from && oauth.from === 'auth0') {
      return true;
    } else {
      return oauth && oauth.expires_at && oauth.expires_at > Date.now();
    }
  }

  return service;
};

authService.$inject = $inject;

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js